import absoluteUrl from 'next-absolute-url'
import _flatMap from 'lodash/flatMap'
import _map from 'lodash/map'

import Faq from 'containers/Faq'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { data } from 'constant/faq'

export default function Index({ canonical }) {
  const metaTitle = '24 FIX | FAQ'
  const metaDescription = '24 FIX | FAQ คำถามที่พบบ่อย'
  const faqItems = _flatMap(data?.categories, category => category?.contents || [])

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        pathUrl={canonical}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: _map(faqItems, item => ({
            '@type': 'Question',
            name: item?.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item?.answer,
            },
          })),
        }}
      />

      <Layout>
        <Faq data={data} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req } = context
  const { origin } = absoluteUrl(req)

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/faq`,
      })
    ),
  }
}
